

import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  Space,
  Row,
  Col,
  Card,
  Table,
  DatePicker,
  Modal,
  Select,
  Input,
} from "antd";
import dayjs from "dayjs";
import PageTitle from "components/PageTitle";
import TableBar from "components/TableBar";
import { toast } from "react-toast";
import { parseQueryParams, stringifyQueryParams } from "utils/url";
import FilterDrawer from "./FilterDrawer";
import { omitBy, isEmpty } from "lodash";
import { Tabs } from "antd";
import {
  ChevronDownIcon,
  RefreshIcon,
  MenuAlt1Icon,
  ViewGridIcon,
} from "@heroicons/react/outline";
import { BaseSelect } from "components/Elements";
import OrderCardView from "./OrderCardView";
import OrderListView from "./OrderListView";
import api from "utils/api";
import SelectOptionExample from "components/Elements/BaseSelect/SelectOptionExample.js";
// styles
import "assets/styles/orders.scss";
// request
import { payoutgetPartnerSummary } from "requests/statistic";
import { getWlletList, walletChangeStatus } from "requests/order";
import { format } from 'date-fns';
const { RangePicker } = DatePicker;

const titles = [{ title: "Authentication" }];
// const handleChange = (value) => {
//   console.log(`selected ${value}`);
// };

function WalletReport() {
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [page, setPage] = useState();
  const [perPage, setPerPage] = useState(
    process.env.REACT_APP_RECORDS_PER_PAGE
  );
  const [totalCount, setTotalCount] = useState(0);
  const [records, setRecords] = useState([]);
  const searchRef = useRef(null);
  const [isShowFilter, setIsShowFilter] = useState(false);
  const [filter, setFilter] = useState(null);
  const [BankDetails, setBankDetails] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const { RangePicker } = DatePicker;
  const [modal2Open, setModal2Open] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isStatusModalVisible, setIsStatusModalVisible] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const [currentRemark, setCurrentRemark] = useState(null);
  const [formData1, setFormData] = useState({
    // company_id: "",
    status: "",
    reason: ""
  });
  const config = useSelector((state) => state.config);
  const hasRunOnce = useRef(false);

  const handleStatusClick1 = (id, status) => {
    setCurrentId(id);
    setCurrentRemark(status);
    setIsStatusModalVisible(true);
  };
  const handleStatusChange  = (value) => {
    setFormData({ ...formData1, status: value });
  };
   const handleReasonChange   = (e) => {
    setFormData({ ...formData1,reason: e.target.value  });
  };
//   const handleInputChange = (value, field = "status") => {
//   setFormData((prev) => ({ ...prev, [field]: value }));
// };


  const handleStatusOk = async () => {
    if (!currentId) {
      toast.error("No transaction ID found.");
      return;
    }
    if (!formData1.status) {
      toast.error("Please select a status.");
      return;
    }
  //    if (!formData1.reason) {
  //   toast.error("Please enter a reason.");
  //   return;
  // }
    if (formData1.status === "failed" && !formData1.reason.trim()) {
    toast.error("Please provide a reason for failure.");
    return;
  }


    console.warn(currentId, currentRemark);


    setIsTableLoading(true);
    try {
      const payload = {
        id: currentId,
        tr_status: formData1.status, // ⬅️ Use `tr_status` exactly as required
        // reason: formData1.reason,
          reason: formData1.reason || "", // Optional, if not "failed"

      };
      const response = await walletChangeStatus(payload);
      if (response.status === 1) {
        const query = parseQueryParams(location);
        await getData(query);
      } else {

      }


    } catch (error) {
      console.error("Error updating status:", error);
    } finally {
      setIsTableLoading(false);
      setIsStatusModalVisible(false); // Close the modal after update
      setFormData({ status: "",reason:"" });
    }
  };
  //for wallet tab//
  const items = [
    {
      key: "1",
      label: "Wallet Report",
    },
  ];
  const onChange = (key) => {
    console.log(key);
  };
  // const handleStatusOk = () => {
  //   setIsStatusModalVisible(false);
  // };

  // const handleStatusCancel = () => {
  //   setIsStatusModalVisible(false);
  // };


  const columns = [
    {
      title: "SR.No",
      render: (text, record, index) => index + 1,
    },
    {
      title: "User ID / Date / Time",
      render: (text, record) => {
        // Safely parse and format date_time
        let dateStr = "N/A";
        if (record.date_time) {
          const dateObj = new Date(record.date_time);
          if (!isNaN(dateObj)) {
            dateStr = format(dateObj, 'dd-MM-yyyy HH:mm a');
          }
        }

        return (
          <div>
            {record.user_id}
            <br />
            {dateStr}
          </div>
        );
      },
    },
    {
      title: "Service Name",
      render: (text, record) => (
        <div>{record.type || "-"}</div> // Assuming 'type' represents the service
      ),
    },
    {
      title: "Customer Details",
      render: (text, record) => (
        <div>
          <strong>Username:</strong> {record.username || "-"}
          <br />
          <strong>Mobile:</strong> {record.user_mobile || "-"}
        </div>
      ),
    },
    {
      // title: "Transaction ID / Order ID",
      title: "UTR/RRN Number",
      render: (text, record) => (
        <div>
          {/* <strong>Transaction ID:</strong> {record.trn_number || "-"} */}
          {record.trn_number || "-"}
        </div>
      ),
    },
    {
      title: "Transfer Amount",
      render: (text, record) => (
        <div>
          <strong>Amount:</strong> {record.amount || "-"}
        </div>
      ),
    },
    {
      title: "Bank Name",
      dataIndex: "bank_name",
      key: "bank_name",
    },
    {
      title: "Payment Method",
      dataIndex: "payment_method",
      key: "payment_method",
    },
    {
      title: "Remark",
      dataIndex: "remark",
      key: "remark",
    },
    {
      title: "Status",
      render: (text, record) => {
        const getStatusColor = (status) => {
          switch (status?.toLowerCase()) {
            case "success":
              return "green";
            case "failed":
              return "red";
            case "inprocess":
              return "#ff3100";
            case "pending":
              return "#c500ff";
            default:
              return "black";
          }
        };

        return (
          <>
            <div
              style={{
                color: getStatusColor(record.tr_status),
                textTransform: "uppercase",
                fontFamily: "cursive",
                fontWeight: "900",
              }}
            >
              {record.tr_status || "-"}
            </div>
            <br />
            {/* <Button
              type="primary"
              onClick={() => handleStatusClick1(record._id, record.tr_status)}
            >
              Change Status
            </Button> */}
             {record.tr_status?.toLowerCase() === "pending" && (
          <Button
            type="primary"
            onClick={() => handleStatusClick1(record._id, record.tr_status)}
          >
            Change Status
          </Button>
        )}
          </>
        );
      },
    },
  ];


  useEffect(() => {
    const query = parseQueryParams(location);
    if (!hasRunOnce.current) {
      hasRunOnce.current = true;

      if (query.tr_status) {
        delete query.tr_status;

        navigate(
          {
            pathname: location.pathname,
            search: stringifyQueryParams(query),
          },
          { replace: true }
        );
        return;
      }
    }
    getData(query);
  }, [location]);



  const getData = async (query) => {
    try {
      setIsTableLoading(true);
      const response = await getWlletList(query);
      console.log("Full response:", response);
      if (response.status === "1" || response.status === 1) {

        let recordsFromApi = response.data || [];
        console.log("recordFrom api", recordsFromApi);
        const selectedStatus = query.tr_status ? query.tr_status.toLowerCase() : null;

        if (selectedStatus) {
          recordsFromApi = recordsFromApi.filter((item) => {
            return item.tr_status?.toLowerCase() === selectedStatus;
          });
        } else {
          // No status selected, filter by allowed statuses (optional)
          const allowedStatuses = ["pending", "success", "failed", "inprocess"];
          recordsFromApi = recordsFromApi.filter((item) => {
            const status = item.tr_status?.toLowerCase?.().trim();
            return allowedStatuses.includes(status);
          });
        }

        setRecords([...recordsFromApi]);
        setPage(response.data.current_page);
        setPerPage(response.data.per_page);
        setTotalCount(response.data.total);
      } else {
        toast.error(response.message || "Failed to fetch wallet data.");
      }
    } catch (err) {
      toast.error("Error while fetching wallet data.");
    } finally {
      setIsTableLoading(false);
    }
  };


  const onChangeTable = (pagination) => {
    let query = parseQueryParams(location);
    query = {
      ...query,
      page: pagination.current,
      per_page: pagination.pageSize,
    };

    navigate({
      pathname: location.pathname,
      search: stringifyQueryParams(query),
    });
  };

  const onToggleFilter = () => {
    setIsShowFilter(!isShowFilter);
  };

  const onSearch = (keyword) => {
    let query = parseQueryParams(location);
    query = {
      ...query,
      page: 1,
      keyword: keyword,
    };

    navigate({
      pathname: location.pathname,
      search: stringifyQueryParams(query),
    });
  };

  const onChangeDates = (dates) => {
    let query = parseQueryParams(location);

    if (dates) {
      query = {
        ...query,
        created_at_date_min: dayjs(dates[0]).format("YYYY-MM-DD"),
        created_at_date_max: dayjs(dates[1]).format("YYYY-MM-DD"),
      };
    } else {
      delete query.created_at_date_min;
      delete query.created_at_date_max;
    }

    navigate({
      pathname: location.pathname,
      search: stringifyQueryParams(query),
    });
  };

  const onExport = async () => {
    try {
      let query = parseQueryParams(location);
      setIsTableLoading(true);
      const response = await getWlletList(query);
      // alert(response.filepath);
      if (response.filepath) {
        window.open(
          `${process.env.REACT_APP_ASSET_URL}${response.filepath}`,
          "_blank"
        );
      }
    } catch (err) {
      toast.error("An error occurred. Please try again.");
    } finally {
      setIsTableLoading(false);
    }
  };

  const onChangeFilter = (name, e, isMuilty = false) => {
    if (isMuilty) {
      setFilter((preState) => ({ ...preState, [name]: e.join(",") }));
    } else {
      setFilter((preState) => ({ ...preState, [name]: e }));
    }
  };

  const onChangePaymentStatus = (value) => {
    let query = parseQueryParams(location);

    if (value) {
      query = {
        ...query,
        tr_status: value,

      };
    } else {
      delete query.tr_status;
    }

    navigate({
      pathname: location.pathname,
      search: stringifyQueryParams(query),
    });
  };
  const fetchManagerList = async (id) => {
    setIsTableLoading(true);
    try {
      const response = await api.post(
        `/manager/summary/payout-transaction-bank-details/${id}`,
        {
          //   id: keyword
        }
      );
      // alert('demo');
      console.warn(response.data.record.Ifsc);
      // return;
      //console.warn(response.data.records);
      // const data = await response.data.records.json();
      // console.warn(data);
      // const data =  response;

      setBankDetails(response.data.record);

      //  console.warn(response.data.records);
    } catch (error) {
      console.error("Error fetching manager list:", error);
    }
    setIsTableLoading(false);
  };

  // const handleStatusClick1 = (id, remark) => {
  //   setIsStatusModalVisible(remark);
  //   setIsStatusModalVisible(true);
  //        setCurrentId(id);
  // };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  // const handleStatusOk = () => {
  //   setIsStatusModalVisible(false);
  //   handleChange();
  // };

  const handleStatusCancel = () => {
    setIsStatusModalVisible(false);
  };

  const payStatuses = [
    { value: "Pending", display: "Pending" },
    { value: "success", display: "Success" },
    // { value: "inprocess", display: "Inprocess" },
    { value: "failed", display: "Failed" },
  ];

  return (
    <div>
      <div>
        <Tabs
          defaultActiveKey="1"
          items={items}
          onChange={onChange}
          indicatorSize={(origin) => origin - 16}
        />
      </div>
      <Row gutter={[8, 8]} justify={"space-between"} align={"middle"}>
        <Col xs={24} md={24} lg={8} xl={6}>
          <Card className="small_card">
            <SelectOptionExample
              options={payStatuses}
              selected={new URLSearchParams(location.search).get("tr_status") || ""}
              onChange={(value) => {
                onChangePaymentStatus(value);
              }}

            />

          </Card>
        </Col>
        <Col xs={24} md={24} lg={8} xl={6}>
          <Card className="small_card">
            <TableBar
              placeholderInput="Customer details/ Merchant details"
              children={
                <Space className="mb-8 action-button">
                  <BaseSelect
                    options={config.pay_statuses}
                    optionLabel="display"
                    optionValue="value"
                    defaultText="Status"
                    selected={new URLSearchParams(location.search).get("tr_status") || ""}
                    style={{ width: 230 }}
                    onChange={(value) => onChangePaymentStatus(value)}
                  />

                </Space>
              }
              onSearch={onSearch}
              onFilter={onToggleFilter}
              isActiveFilter={isShowFilter}
              inputRef={searchRef}
              showFilter={false}
            />
          </Card>
        </Col>
        <Col xs={24} md={24} lg={10} xl={8}>
          <Card className="small_card">
            <Space>
              <RangePicker
                onCalendarChange={(newDates) => onChangeDates(newDates)}
              />

              <Button type="primary" size="large" target="_blank" onClick={onExport}>
                Export
              </Button>

            </Space>
          </Card>
        </Col>
      </Row>

      <Table
        loading={isTableLoading}
        dataSource={records}
        columns={columns}
        onChange={onChangeTable}
        rowKey={"_id"}
        pagination={{
          pageSize: perPage,
          total: totalCount,
          current: page,
        }}
        scroll={{
          x: true,
        }}
      />
      <Modal
        title="Change Wallet Status"
        visible={isStatusModalVisible}
        onOk={handleStatusOk}
        onCancel={handleStatusCancel}
      >
        <Select

          placeholder="Select new status"
          allowClear
          onChange={handleStatusChange}
          value={formData1.status}
          style={{ width: "100%", color: "black" }}
          options={[
            { value: "", label: "Please Select", disabled: true },
            { value: "success", label: "Success" },
            // { value: "pending", label: "Pending" },
            { value: "failed", label: "Failed" },
            // { value: "inprocess", label: "Inprocess" },
          ]}

        />  

        {formData1.status === "failed" && (
    <>
      <label htmlFor="reason">Reason</label>
      <Input
        id="reason"
        placeholder="Enter reason"
        value={formData1.reason}
         onChange={handleReasonChange}
      />
    </>
  )}



      </Modal>

    </div>
  );
}
export default WalletReport;

